import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminLogin = () => {
  const { user, login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <form
        onSubmit={onSubmit}
        className="bg-ivory border-2 border-gold p-12 max-w-md w-full shadow-2xl"
      >
        <div className="text-center mb-10">
          <div className="w-3 h-3 rotate-45 bg-gold mx-auto mb-4 border-2 border-dark-crimson" />
          <h1
            className="text-3xl font-bold text-dark-green tracking-widest"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            CHIMERA · ADMIN
          </h1>
          <div className="h-px w-24 bg-gold mx-auto mt-4" />
        </div>

        {error && (
          <div
            data-testid="login-error"
            className="bg-dark-crimson/10 border-l-4 border-dark-crimson text-dark-crimson p-3 mb-6 text-sm"
          >
            {String(error)}
          </div>
        )}

        <label className="block text-dark-green text-sm tracking-wider mb-1 uppercase">
          Username
        </label>
        <input
          data-testid="admin-username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          required
          className="w-full p-3 mb-6 bg-cream border-2 border-gold/40 focus:border-dark-crimson outline-none text-dark-green text-lg"
        />

        <label className="block text-dark-green text-sm tracking-wider mb-1 uppercase">
          Password
        </label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full p-3 mb-8 bg-cream border-2 border-gold/40 focus:border-dark-crimson outline-none text-dark-green text-lg"
        />

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          className="w-full bg-dark-crimson text-cream py-4 tracking-widest font-semibold hover:bg-dark-green transition-colors disabled:opacity-60"
        >
          {busy ? 'Signing in…' : 'Enter'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
